<script setup lang="ts">
import { ref, computed, watch } from "vue"
import FormRow from "@/components/Common/FormRow.vue"
import EmailGenerate from "@/components/AccountParts/EmailGenerate.vue"

const emits = defineEmits(['update:modelValue', 'generate'])
const props = withDefaults(
    defineProps<{
    title: string
    errors: string[]
    type?: string
    id?: string
    modelValue?: any
    textType?: string
    required?: boolean
    disabled?: boolean
    isGenerate: boolean
    driverId?: string
    officeId?: number | null
    generateButtonName?: string
  }>(),
  {
    type: 'text',
    maskable: false,
    passwordGenerator: false,
    required: false,
    copiable: false,
    isGenerate: false,
  }
)

const errorsArray = ref([] as string[])

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function displayError(errors: string[]) {
  errorsArray.value = errors
}

watch(() => props.errors, (value) => {
  errorsArray.value = value
})
</script>
<template>
  <FormRow
    :title="props.title"
    :text="modelValue"
    :required="props.required"
  >
    <div class="d-flex">
      <v-text-field
        :id="id"
        hide-details="auto"
        class="small pt-2"
        v-model="modelValue"
        type="text"
        density="compact"
        :disabled="props.disabled"
        :error-messages="errorsArray"
      />
      <EmailGenerate
        v-if="props.isGenerate"
        class="ml-4 mt-2"
        :driverId="props.driverId"
        :officeId="props.officeId"
        v-model="modelValue"
        :buttonName="props.generateButtonName"
        @displayError="displayError"
      />
    </div>
  </FormRow>
</template>
